<template>
  <v-menu
    bottom
    left
    offset-y
    content-class="procedure-report-row-actions-menu">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        :disabled="disabled"
        icon
        solo
        @click.stop>
        <v-icon
          color="primary"
          size="20">
          mdi-dots-vertical
        </v-icon>
      </v-btn>
    </template>

    <v-list dense>
      <v-list-item
        v-if="canApprove"
        class="procedure-report-row-action-item primary--text"
        @click.stop="$emit('approve', item)">
        <v-list-item-icon class="procedure-report-row-action-item__icon">
          <v-icon size="18">
            mdi-check-circle-outline
          </v-icon>
        </v-list-item-icon>
        <v-list-item-title>
          {{ $t('procedureReport.actions.rowActions.approve') }}
        </v-list-item-title>
      </v-list-item>

      <v-list-item
        v-if="canShowJustification"
        class="procedure-report-row-action-item primary--text"
        @click.stop="$emit('justification', item)">
        <v-list-item-icon class="procedure-report-row-action-item__icon">
          <v-icon size="18">
            mdi-text-box-outline
          </v-icon>
        </v-list-item-icon>
        <v-list-item-title>
          {{ $t('procedureReport.actions.rowActions.editRule') }}
        </v-list-item-title>
      </v-list-item>

      <v-list-item
        v-if="canShowHistory"
        class="procedure-report-row-action-item primary--text"
        @click.stop="$emit('history', item)">
        <v-list-item-icon class="procedure-report-row-action-item__icon">
          <v-icon size="18">
            mdi-history
          </v-icon>
        </v-list-item-icon>
        <v-list-item-title>
          {{ $t('procedureReport.actions.rowActions.updateHistory') }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { isPendingApprovalProcedure } from '@/store/modules/procedure-report/procedure-report-config';
import { hasClassificationJustification } from '@/store/modules/procedure-report/procedure-report-factory';

export default {
  name: 'ProcedureReportRowActionsMenu',
  props: {
    item: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    canApprove() {
      return isPendingApprovalProcedure(this.item);
    },
    canShowJustification() {
      return hasClassificationJustification(this.item);
    },
    canShowHistory() {
      return !this.item.isNew;
    },
  },
};
</script>

<style lang="scss">
.procedure-report-row-actions-menu {
  .procedure-report-row-action-item {
    min-height: 40px;
    padding: 0 12px;

    &__icon {
      align-self: center;
      justify-content: center;
      margin: 0 12px 0 0 !important;
      min-width: 24px !important;
    }

    .v-list-item__title {
      flex: 1 1 auto;
    }
  }
}
</style>
